module.exports = __webpack_public_path__ + "img/CHICMAX-icon.c09d7719.jpg";